<template>
  <MarkupGenerator
    v-if="store.product?.ShortDescription"
    :page-data="markupData"
    :is-page="false"
  />
</template>

<script lang="ts" setup>
import type { MarkupData } from '~/repository/modules/category.module';

const store = useMyProductPageStore();

const markupData: Ref<MarkupData | null> = ref(null);
if (store.product?.ShortDescription) {
  markupData.value = {
    PageContent: store.product.ShortDescription,
  };
}
</script>

<style lang="scss" scoped></style>
